import axios from '../Util/axiosConfig';

// constants
import { baseUrl } from '../Contants';

export const logout = () => {
  localStorage.clear();
  sessionStorage.clear();
  return axios.get(`${baseUrl}/api/auth/logout`);
};

// products actions

export const getProductsWithFilters = (url) => {
  return axios.get(`${baseUrl}/api/user/products${url}`);
};

// New parallel product search (super = fuzzy single box, advanced = per-field)
export const superSearch = (params) => {
  const qs = new URLSearchParams(params).toString();
  return axios.get(`${baseUrl}/api/user/search/super?${qs}`);
};

export const advancedSearch = (body) => {
  return axios.post(`${baseUrl}/api/user/search/advanced`, body);
};

export const getProductDetails = (productId, roleId) => {
  return axios.get(`${baseUrl}/api/user/product/${productId}/${roleId}`);
};

export const getMergedProductDetails = (productId, roleId) => {
  return axios.get(`${baseUrl}/api/user/product/merged/${productId}/${roleId}`);
};

export const updateRPO = (rpoData) => {
  const url = `${baseUrl}/api/user/rpo`;
  return axios.post(url, { rpoData });
};

// Discontinue / reactivate a whole style, or only the options whose cost_ids are
// passed. Admin + read/write only (readWriteMiddleware on the route).
export const setProductDiscontinued = ({
  product_uuid,
  discontinued,
  cost_ids,
}) => {
  const url = `${baseUrl}/api/user/product/discontinue`;
  return axios.put(url, { product_uuid, discontinued, cost_ids });
};

// product actions
export const updateProduct = (
  costId,
  margin,
  effectiveStartDate,
  effectiveEndDate,
  comments
) => {
  const data = { margin, effectiveStartDate, effectiveEndDate, comments };
  const url = `${baseUrl}/api/user/costs/${costId}/margin`;
  return axios.put(url, data);
};

export const resetMargin = (marginId) => {
  const url = `${baseUrl}/api/user/margins/${marginId}`;
  return axios.delete(url);
};

// user actions
export const getUserNames = () => {
  return axios.get(`${baseUrl}/api/admin/usernames`);
};

export const userNameExists = (user) => {
  return axios.get(`${baseUrl}/api/signup/user/valid/?user=${user}`);
};

export const confirmUserReg = (reset_token) => {
  return axios.get(`${baseUrl}/api/confirmuserreg/${reset_token}`);
};

export const createUser = (userName, phone, accessTypeCode) => {
  const url = `${baseUrl}/api/admin/users`;
  return axios.post(url, { userName, phone, accessTypeCode });
};

export const registerLocalUser = (
  name,
  email,
  username,
  phone,
  password,
  accesstype,
  roleId,
  locationId,
  isRsa,
  contactByEmail,
  contactByPhone
) => {
  const url = `${baseUrl}/api/signupInternal`;
  return axios.post(url, {
    name,
    email,
    username,
    phone,
    password,
    accesstype,
    roleId,
    locationId,
    isRsa,
    contactByEmail,
    contactByPhone
  });
};

export const customerRegisterLocalUser = (
  name,
  email,
  username,
  phone,
  password,
  key,
  contactByEmail,
  contactByPhone
) => {
  const url = `${baseUrl}/api/signup`;
  return axios.post(url, { name, email, username, phone, password, key, contactByEmail, contactByPhone });
};

export const updateUser = (
  name,
  email,
  phone,
  userId,
  roleId,
  accessTypeCode,
  locationId,
  isRsa,
  sample_reminder,
  contactByEmail,
  contactByPhone
) => {
  const url = `${baseUrl}/api/admin/users/${userId}`;
  return axios.put(url, {
    name,
    email,
    phone,
    roleId,
    accessTypeCode,
    locationId,
    isRsa,
    sample_reminder,
    contactByEmail,
    contactByPhone
  });
};

export const updateLocalUser = (name, email, phone, userId, contactByEmail, contactByPhone) => {
  const url = `${baseUrl}/api/user/local/update/${userId}`;
  return axios.put(url, { name, email, phone, contactByEmail, contactByPhone });
};

export const deleteUser = (userId) => {
  const url = `${baseUrl}/api/admin/users/${userId}`;
  return axios.delete(url);
};

export const createRole = (
  role_name,
  role_description,
  prefix,
  auto_checkout_sample,
  sample_reminder
) => {
  const url = `${baseUrl}/api/admin/roles/`;
  return axios.post(url, {
    role_name,
    role_description,
    prefix,
    auto_checkout_sample,
    sample_reminder,
  });
};

export const upsertRoleToMargin = (
  role_id,
  material_class_cd,
  margin,
  add_to_cost,
  add_to_price,
  disclaimer,
  loaded_margin,
  loaded_markup
) => {
  const url = `${baseUrl}/api/admin/roles/${role_id}/margins/`;
  return axios.post(url, {
    role_id,
    material_class_cd,
    margin,
    add_to_cost,
    add_to_price,
    disclaimer,
    loaded_margin,
    loaded_markup,
  });
};

// Cost adjustment rules (admin Cost Adjustments page).
export const getCostAdjustments = () => {
  return axios.get(`${baseUrl}/api/admin/costadjustments`);
};

export const getCostAdjustmentScopes = () => {
  return axios.get(`${baseUrl}/api/admin/costadjustments/scopes`);
};

export const saveCostAdjustment = (rule) => {
  return axios.post(`${baseUrl}/api/admin/costadjustments/save`, rule);
};

export const deleteCostAdjustment = (cost_adjustment_id) => {
  return axios.post(`${baseUrl}/api/admin/costadjustments/delete`, { cost_adjustment_id });
};

export const getRoles = () => {
  return axios.get(`${baseUrl}/api/admin/roles`);
};

export const getUnitConversions = () => {
  return axios.get(`${baseUrl}/api/admin/unitconversions`);
};

export const createUnitConversion = (
  material_class_cd,
  source_uom_type_cd,
  target_uom_type_cd,
  conversion_factor
) => {
  return axios.post(`${baseUrl}/api/admin/unitconversions`, {
    material_class_cd,
    source_uom_type_cd,
    target_uom_type_cd,
    conversion_factor,
  });
};

export const deleteUnitConversion = (unit_conversion_id) => {
  return axios.put(`${baseUrl}/api/admin/unitconversions/delete`, {
    unit_conversion_id,
  });
};

export const getAccessTypes = () => {
  return axios.get(`${baseUrl}/api/admin/accesstypes`);
};

export const updateRole = (
  role_id,
  role_name,
  role_description,
  prefix,
  auto_checkout_sample,
  sample_reminder
) => {
  const url = `${baseUrl}/api/admin/roles/${role_id}`;
  return axios.post(url, {
    role_name,
    role_description,
    prefix,
    auto_checkout_sample,
    sample_reminder,
  });
};

export const updateUserRole = (role_id) => {
  const url = `${baseUrl}/api/admin/updateuserrole/${role_id}`;
  return axios.post(url, { role_id });
};

export const editRolePrefix = (role_id, switch_state) => {
  const url = `${baseUrl}/api/admin/roleprefix`;
  return axios.post(url, { role_id, switch_state });
};

export const deleteRole = (role_id) => {
  const url = `${baseUrl}/api/admin/roles/${role_id}`;
  return axios.delete(url, { role_id });
};

// announcement actions
export const createAnnouncement = (
  title,
  announcement,
  effectStartDate,
  effectEndDate
) => {
  const url = `${baseUrl}/api/admin/announcements`;
  return axios.post(url, {
    title,
    announcement,
    effectStartDate,
    effectEndDate,
  });
};

export const updateAnnouncement = (
  announcementId,
  title,
  announcement,
  effectStartDate,
  effectEndDate
) => {
  const url = `${baseUrl}/api/admin/announcements/${announcementId}`;
  return axios.put(url, {
    title,
    announcement,
    effectStartDate,
    effectEndDate,
  });
};

export const deleteAnnouncement = (announcementId) => {
  const url = `${baseUrl}/api/admin/announcements/${announcementId}`;
  return axios.delete(url);
};

// bulletin actions

export const createBulletin = (data) => {
  const url = `${baseUrl}/api/admin/bulletin`;
  return axios.post(url, data);
};

export const deleteBulletin = (id) => {
  const url = `${baseUrl}/api/admin/bulletin/${id}`;
  return axios.delete(url);
};

export const updateBulletin = (bulletinId, data) => {
  const url = `${baseUrl}/api/admin/bulletins/${bulletinId}`;
  return axios.put(url, data);
};

// print actions
export const updatePrintQueue = (productUUIDList) => {
  const url = `${baseUrl}/api/user/queue`;
  return axios.post(url, { productUUIDList });
};

export const deleteFromPrintQueue = (printQueueId) => {
  const url = `${baseUrl}/api/user/products/${printQueueId}/queue`;
  return axios.delete(url);
};

export const clearPrintQueue = () => {
  const url = `${baseUrl}/api/user/queue`;
  return axios.delete(url);
};

export const printPreview = () => {
  return axios.get(`${baseUrl}/api/user/queue/print`);
};

// tax update actions

export const updateTaxRate = (taxRate) => {
  const url = `${baseUrl}/api/admin/taxrate/update`;
  return axios.post(url, { taxRate });
};

export const updateCompanyMargin = (companyMargin) => {
  const url = `${baseUrl}/api/admin/margin/company`;
  return axios.post(url, { marginCompanyRate: Number(companyMargin) });
};

export const updateLoadedMargin = (loadedMargin) => {
  const url = `${baseUrl}/api/admin/margin/loaded`;
  return axios.post(url, { marginLoadedRate: Number(loadedMargin) });
};

// Sales Tax

export const updateSalesTaxRate = (salesTaxRate) => {
  return axios.post(`${baseUrl}/api/admin/salestaxrate/update`, {
    salesTaxRate,
  });
};

// login actions

export const startGoogleAuth = () => {
  return axios.get(`${baseUrl}/api/auth/google/initiate`)
}

export const startMicrosoftAuth = () => {
  return axios.get(`${baseUrl}/api/auth/microsoft/initiate`)
}

export const forgotPassword = (username) => {
  return axios.get(`${baseUrl}/api/auth/forgot-password/${username}`);
};

export const login = (username, password) => {
  return axios.post(`${baseUrl}/api/login`, { username, password });
};

export const changePassword = (newPassword, confirmPassword, userId) => {
  return axios.post(`${baseUrl}/api/auth/local/user/password-change`, {
    newPassword,
    confirmPassword,
    userId,
  });
};

export const resetPassword = (
  resetToken,
  user_name,
  newPassword,
  confirmPassword
) => {
  const url = `${baseUrl}/api/auth/reset-password/${resetToken}`;
  return axios.post(url, { user_name, newPassword, confirmPassword });
};

export const uploadLogo = (data) => {
  const url = `${baseUrl}/api/admin/company/logo`;
  return axios.post(url, data);
};

// manual file uploads actions
export const getTransformDistributorList = (transformTypes) => {
  return axios.get(`${baseUrl}/api/upload/distributor`, { params: transformTypes ? { transformTypes } : {} });
};

export const getPreview = (data) => {
  const url = `${baseUrl}/api/upload/file`;
  return axios.post(url, data);
};

export const confirmManualUpload = (data) => {
  const url = `${baseUrl}/api/upload/file/confirm`;
  return axios.post(url, data);
};

// Does this file's header row match one of this site's mapped imports? Headers are parsed in the
// browser, so identifying a file never ships its contents to the server.
export const detectMapping = (headers, fileName, distributorName) => {
  const url = `${baseUrl}/api/upload/ingestion/detect-mapping`;
  return axios.post(url, { headers, fileName, distributorName });
};

// The mappings this site actually imports through, for the upload dialog's standing banner.
export const getHouseErp = () => {
  return axios.get(`${baseUrl}/api/upload/ingestion/house-erp`);
};

export const getTemplateHeader = () => {
  return axios.get(`${baseUrl}/api/upload/templateheader`);
};

// File export actions
export const getDataExportList = () => {
  return axios.get(`${baseUrl}/api/exports/`);
};

export const getDataExportPreview = (
  export_id,
  action,
  role,
  manufacturers,
  materials,
  styles,
  distributors
) => {
  let req = {
    role: JSON.parse(role),
    manufacturers: JSON.parse(manufacturers),
    materials: JSON.parse(materials),
    distributors: JSON.parse(distributors),
    styles: JSON.parse(styles),
  };
  const url = `${baseUrl}/api/exports/${export_id}/${action}`;
  return axios.post(url, req);
};

export const getManufacturers = () => {
  return axios.get(`${baseUrl}/api/ref/manufacturers`);
};

export const getDistributors = () => {
  return axios.get(`${baseUrl}/api/ref/distributors`);
};

export const getMaterials = () => {
  return axios.get(`${baseUrl}/api/ref/materials`);
};

export const getStyles = () => {
  return axios.get(`${baseUrl}/api/ref/styles`);
};

export const getTemplate = () => {
  const url = `${baseUrl}/api/upload/gettemplate`;
  return axios.post(url);
};

// disclaimer actions
export const getTaxDisclaimer = () => {
  return axios.get(`${baseUrl}/api/admin/taxdisclaimer`);
};

export const updateTaxDisclaimer = (tax_disclaimer) => {
  const url = `${baseUrl}/api/admin/disclaimer/tax`;
  return axios.post(url, { tax_disclaimer });
};

export const getProductDisclaimer = () => {
  return axios.get(`${baseUrl}/api/admin/disclaimer/product`);
};

export const updateProductDisclaimer = (product_disclaimer) => {
  const url = `${baseUrl}/api/admin/disclaimer/product`;
  return axios.post(url, { product_disclaimer });
};

// Product status (active, discontinued)
export const updateProductStatus = (cost_id, product_uuid, position) => {
  const url = `${baseUrl}/api/admin/product/status/set`;
  return axios.post(url, { cost_id, product_uuid, position });
};

// Logo Link
export const setLogoLink = (company_link) => {
  const url = `${baseUrl}/api/admin/logolink/set`;
  return axios.post(url, { company_link });
};

export const getLogoLink = () => {
  return axios.get(`${baseUrl}/api/admin/logolink/get`);
};

// Roomvo

export const getRoomvoToggle = () => {
  const url = `${baseUrl}/api/admin/getroomvotoggle`;
  return axios.get(url);
};

export const setRoomvoToggle = (value) => {
  const url = `${baseUrl}/api/admin/setroomvotoggle`;
  return axios.post(url, { value });
};

// Notifications

export const getSampleReminderConfig = () => {
  const url = `${baseUrl}/api/admin/samplereminder/getconfig`;
  return axios.get(url);
};

export const setSampleReminderConfig = (checkoutPeriod, pastDueLimit, pastDueFrequency, dailyStart, dailyEnd) => {
  const url = `${baseUrl}/api/admin/samplereminder/setconfig`;
  return axios.post(url, { 
    checkoutPeriod,
    pastDueLimit,
    pastDueFrequency,
    dailyStart,
    dailyEnd
  });
};

// Product Info

export const getProductLookBack = (days) => {
  return axios.get(`${baseUrl}/api/user/lookback/${days}`);
};

export const getProductDescription = (puuid) => {
  return axios.get(`${baseUrl}/api/admin/product/description/${puuid}`);
};

export const setProductDescription = (
  product_description,
  product_image,
  puuid
) => {
  const url = `${baseUrl}/api/admin/product/setdescription`;
  return axios.post(url, { product_description, product_image, puuid });
};

export const getProductData = (path) => {
  return axios.get(`${baseUrl}/api/${path}`);
};

export const getProductV2Data = (path, config = {}) => {
  return axios.get(`${baseUrl}/api/${path}`, config);
};

// Deferred size-selector data — fetched in the background after the price card
// renders, only when page_config.should_combine_sizes is on. `path` already has
// the `/like-sizes` suffix inserted before any query string.
export const getProductV2LikeSizes = (path, config = {}) => {
  return axios.get(`${baseUrl}/api/${path}`, config);
};

// File history

export const getLatestB2B = () => {
  return axios.get(`${baseUrl}/api/files/b2b/latest`);
};

export const getFilesByPartner = (partner) => {
  return axios.get(`${baseUrl}/api/files/b2b/partners/${partner}`);
};

export const getProductsByFilename = (filename) => {
  return axios.get(`${baseUrl}/api/files/b2b/${filename}/products`);
};

export const deleteCostHistory = (file_name) => {
  const url = `${baseUrl}/api/files/manual/delete`;
  return axios.post(url, { file_name });
};

export const deleteCostRecordsByProduct = (product_uuid) => {
  const url = `${baseUrl}/api/files/manual/deletebyproduct`;
  return axios.post(url, { product_uuid });
};

export const deleteCostRecordsByCostId = (cost_id) => {
  const url = `${baseUrl}/api/files/manual/deletebycostid`;
  return axios.post(url, { cost_id });
};

// Get S3
export const listS3Files = () => {
  return axios.get(`${baseUrl}/api/files/manual/`);
};

export const getS3Files = (file) => {
  const url = `${baseUrl}/api/files/manual/download`;
  return axios.post(url, { file });
};

// Stats

export const getViewsByDay = (
  sDate,
  eDate,
  role,
  accessCode,
  materialClass,
  locations,
  spoke
) => {
  let req = {
    role: role,
    access_code: accessCode,
    material_class: materialClass,
    locations: locations,
  };
  const url = `${baseUrl}/api/stats/products/Viewsbyday/${sDate}/${eDate}?siteName=${spoke}`;
  return axios.post(url, req);
};

export const getFavoritesHistory = (
  sDate,
  eDate,
  role,
  accessCode,
  locations,
  materialClass,
  names,
  likes,
  unLikes,
  spoke
) => {
  const url = `${baseUrl}/api/stats/history/favorites/${sDate}/${eDate}?siteName=${spoke}`;
  return axios.post(url, {
    role,
    accessCode,
    locations,
    materialClass,
    names,
    likes,
    unLikes,
  });
};

export const getCheckoutsHistory = (
  sDate,
  eDate,
  role,
  accessCode,
  materialClass,
  locations,
  names,
  checkedOut,
  spoke
) => {
  const url = `${baseUrl}/api/stats/history/checkouts/${sDate}/${eDate}?siteName=${spoke}`;
  return axios.post(url, {
    role,
    accessCode,
    materialClass,
    locations,
    names,
    checkedOut,
  });
};

export const getScanDashboard = (
  sDate,
  eDate,
  segment,
  locationId,
  printedOnly,
  spoke,
  signal
) => {
  const url = `${baseUrl}/api/stats/dashboard/${sDate}/${eDate}?siteName=${spoke}`;
  return axios.post(url, { segment, locationId, printedOnly }, { signal });
};

// Loaded separately from the main dashboard so its heavier query doesn't block
// the fast panels.
export const getScanDeadInventory = (
  sDate,
  eDate,
  segment,
  locationId,
  printedOnly,
  spoke,
  signal
) => {
  const url = `${baseUrl}/api/stats/dashboard/dead-inventory/${sDate}/${eDate}?siteName=${spoke}`;
  return axios.post(url, { segment, locationId, printedOnly }, { signal });
};

// Versions
export const getVersion = () => {
  return axios.get(`${baseUrl}/api/version`);
};

export const updateSeenVersion = (version) => {
  return axios.put(`${baseUrl}/api/auth/seen-version`, { version });
};

export const completeOnboarding = () => {
  return axios.put(`${baseUrl}/api/auth/onboarding-complete`);
};

// Mailer
export const setMailer = (
  to,
  fName,
  lName,
  email,
  phone,
  subject,
  messageBody,
  link
) => {
  const url = `${baseUrl}/api/mail/mailer`;
  return axios.post(url, {
    to,
    fName,
    lName,
    email,
    phone,
    subject,
    messageBody,
    link,
  });
};

// Product page settings

export const setManufacturerSwitchPosition = (switch_position) => {
  const url = `${baseUrl}/api/admin/manufacturerposition`;
  return axios.post(url, { switch_position });
};

export const getManufacturerSwitchPosition = () => {
  return axios.get(`${baseUrl}/api/admin/manufacturerposition`);
};

export const setDistributorSwitchPosition = (switch_position) => {
  const url = `${baseUrl}/api/admin/distributorposition`;
  return axios.post(url, { switch_position });
};

export const getDistributorSwitchPosition = () => {
  return axios.get(`${baseUrl}/api/admin/distributorposition`);
};

export const setRoomCalcSwitchPosition = (calc_switch_position) => {
  const url = `${baseUrl}/api/admin/roomcalcposition`;
  return axios.post(url, { calc_switch_position });
};

export const getRoomCalcSwitchPosition = () => {
  return axios.get(`${baseUrl}/api/admin/roomcalcposition`);
};

export const setLocationSwitchPosition = (location_switch_position) => {
  const url = `${baseUrl}/api/admin/locationposition`;
  return axios.post(url, { location_switch_position });
};

export const getLocationSwitchPosition = () => {
  return axios.get(`${baseUrl}/api/admin/locationposition`);
};

export const setProdFavSwitchPosition = (prod_fav_switch_position) => {
  const url = `${baseUrl}/api/admin/prod_fav_position`;
  return axios.put(url, { prod_fav_switch_position });
};

export const getProdFavSwitchPosition = () => {
  return axios.get(`${baseUrl}/api/admin/prod_fav_position`);
};

export const setProdCheckoutSwitchPosition = (
  prod_checkout_switch_position
) => {
  const url = `${baseUrl}/api/admin/prod_checkout_position`;
  return axios.put(url, { prod_checkout_switch_position });
};

export const getProdCheckoutSwitchPosition = () => {
  return axios.get(`${baseUrl}/api/admin/prod_checkout_position`);
};

export const getNotificationsSwitchPos = () => {
  return axios.get(`${baseUrl}/api/settings/notifications/site`);
};

export const setNotificationsSwitchPos = (sample_reminder) => {
  const url = `${baseUrl}/api/settings/notifications/site`;
  return axios.post(url, { sample_reminder });
};

export const getShouldRequireOptionSelection = () => {
  return axios.get(`${baseUrl}/api/admin/requireoptionselection`);
};

export const setShouldRequireOptionSelection = (value) => {
  return axios.post(`${baseUrl}/api/admin/requireoptionselection`, { value });
};

export const getShouldRequireLoginSelection = () => {
  return axios.get(`${baseUrl}/api/admin/requireloginselection`);
};

export const setShouldRequireLoginSelection = (value) => {
  return axios.post(`${baseUrl}/api/admin/requireloginselection`, { value });
};

export const getShowCollectionToCustomer = () => {
  return axios.get(`${baseUrl}/api/admin/showcollectiontocustomer`);
};

export const setShowCollectionToCustomer = (value) => {
  return axios.post(`${baseUrl}/api/admin/showcollectiontocustomer`, { value });
};

export const getShowSpecsToCustomer = () => {
  return axios.get(`${baseUrl}/api/admin/showspecstocustomer`);
};

export const setShowSpecsToCustomer = (value) => {
  return axios.post(`${baseUrl}/api/admin/showspecstocustomer`, { value });
};

export const getCombineStyleSizesSelection = () => {
  return axios.get(`${baseUrl}/api/admin/combinestylesizes`);
};

export const setCombineStyleSizesSelection = (value) => {
  return axios.post(`${baseUrl}/api/admin/combinestylesizes`, { value });
};

export const getShowProductDiscoverySelection = () => {
  return axios.get(`${baseUrl}/api/admin/getshowproductdiscovery`);
};

export const setShowProductDiscoverySelection = (value) => {
  return axios.post(`${baseUrl}/api/admin/setshowproductdiscovery`, { value });
};

export const getShowRelatedProductsSelection = () => {
  return axios.get(`${baseUrl}/api/admin/getshowrelatedproducts`);
};

export const setShowRelatedProductsSelection = (value) => {
  return axios.post(`${baseUrl}/api/admin/setshowrelatedproducts`, { value });
};

// Batched — one call returns every product-page toggle/disclaimer at once.
export const getProductPageSettings = () => {
  return axios.get(`${baseUrl}/api/admin/productpagesettings`);
};

// Batched — one call returns every admin Settings-page toggle at once, keyed by
// app_key with both value columns (app_value / app_value_text).
export const getSettingsPageConfig = () => {
  return axios.get(`${baseUrl}/api/admin/settingspageconfig`);
};

// Locations

export const getLocations = () => {
  return axios.get(`${baseUrl}/api/admin/locations`);
};

export const createLocation = (
  location_name,
  location_description,
  sample_reminder,
  customer_facing_name,
  location_phone,
  location_email,
  default_role_id
) => {
  const url = `${baseUrl}/api/admin/locations`;
  return axios.post(url, {
    location_name,
    location_description,
    sample_reminder,
    customer_facing_name,
    location_phone,
    location_email,
    default_role_id
  });
};

export const deleteLocation = (location_id) => {
  const url = `${baseUrl}/api/admin/locations/${location_id}`;
  return axios.delete(url);
};

export const updateLocation = (
  location_id,
  location_name,
  location_description,
  sample_reminder,
  customer_facing_name,
  location_phone,
  location_email,
  default_role_id
) => {
  const url = `${baseUrl}/api/admin/locations/${location_id}`;
  return axios.post(url, {
    location_name,
    location_description,
    sample_reminder,
    customer_facing_name,
    location_phone,
    location_email,
    default_role_id
  });
};

// Settings

export const getRetailRoundUp = () => {
  return axios.get(`${baseUrl}/api/admin/getroundup`);
};

export const setRetailRoundUp = (retail_round_up) => {
  const url = `${baseUrl}/api/admin/setroundup`;
  return axios.post(url, { retail_round_up });
};

export const getUsePromoPrice = () => {
  return axios.get(`${baseUrl}/api/admin/getusepromoprice`);
};

export const getQrPrintConfig = () => {
  return axios.get(`${baseUrl}/api/settings/print_config/get`);
};

export const setQrPrintConfig = (margins_x, margins_y) => {
  const url = `${baseUrl}/api/settings/print_config/set`;
  return axios.put(url, { margins_x, margins_y });
};

export const getBarcodeConfig = () => {
  return axios.get(`${baseUrl}/api/settings/barcode/get`);
};

export const setBarcodeConfig = (config) => {
  const url = `${baseUrl}/api/settings/barcode/set`;
  return axios.put(url, config);
};

export const setUsePromoPrice = (promo_price_status) => {
  const url = `${baseUrl}/api/admin/setusepromoprice`;
  return axios.post(url, { promo_price_status });
};

// Checkout

export const setSampleAutoCheckoutStatus = (role_id, switch_state) => {
  const url = `${baseUrl}/api/admin/autocheckoutstatus`;
  return axios.post(url, { role_id, switch_state });
};

export const getUserCheckoutStatus = (product_uuid) => {
  return axios.get(
    `${baseUrl}/api/user/product/${product_uuid}/checkout/status/`
  );
};

export const requestSampleCheckout = (productUUID, productSkuUUID, contactByEmail, contactByPhone) => {
  return axios.post(
    `${baseUrl}/api/product/checkout/request`,
    {
      productUUID: productUUID,
      productSkuUUID: productSkuUUID,
      contactByEmail: contactByEmail,
      contactByPhone: contactByPhone
    }
  );
};

export const getCheckoutList = () => {
  return axios.get(`${baseUrl}/api/checkout`);
};

export const returnSample = (sample_checkout_id) => {
  return axios.get(
    `${baseUrl}/api/product/:product_uuid/checkout/return/?sample_checkout_id=${sample_checkout_id}`
  );
};

export const getUserCheckoutList = () => {
  return axios.get(`${baseUrl}/api/user/checkout/`);
};

export const getUserCheckoutListByCustomerId = (customerId) => {
  return axios.get(`${baseUrl}/api/user/${customerId}/checkout/`);
};

export const approveCheckout = (product_uuid, sample_checkout_id) => {
  return axios.get(
    `${baseUrl}/api/user/product/${product_uuid}/checkout/${sample_checkout_id}/approve/`
  );
};

export const checkin = (product_uuid, sample_checkout_id) => {
  return axios.get(
    `${baseUrl}/api/user/product/${product_uuid}/checkout/${sample_checkout_id}/checkin/`
  );
};

export const getCustomerCheckoutStatus = (product_uuid) => {
  return axios.get(`${baseUrl}/api/product/${product_uuid}/checkout/status/`);
};

export const cancelSampleCheckout = (checkoutId) => {
  return axios.get(`${baseUrl}/api/checkout/${checkoutId}/cancel/`);
};

export const setCustomerCreateAccountsSwitchPos = (switch_state) => {
  const url = `${baseUrl}/api/admin/customeraccountcreatestatus`;
  return axios.post(url, { switch_state });
};

export const getCustomerCreateAccountStatus = () => {
  return axios.get(`${baseUrl}/api/admin/customer/account/create/status`);
};

export const getCustomerUserInfo = () => {
  return axios.get(`${baseUrl}/api/user/customer/data`);
};

// Customer favorites
export const likeProduct = (product_uuid, product_sku, location_id) => {
  return axios.get(
    `${baseUrl}/api/product/${product_uuid}/sku/${product_sku}/like/${location_id}`
  );
};

export const unlikeProduct = (product_uuid, product_sku) => {
  return axios.get(
    `${baseUrl}/api/product/${product_uuid}/sku/${product_sku}/unlike`
  );
};

export const likeProductStatus = (product_uuid) => {
  return axios.get(`${baseUrl}/api/product/${product_uuid}/like/status`);
};

export const getLikes = () => {
  return axios.get(`${baseUrl}/api/likes`);
};

export const getAllLikes = () => {
  return axios.get(`${baseUrl}/api/likes/all`);
};

export const getAllLikesByCustomerId = (customerId) => {
  return axios.get(`${baseUrl}/api/likes/user/${customerId}`);
};

export const getCheckoutStatusNames = () => {
  return axios.get(`${baseUrl}/api/admin/checkout/status_names`);
};

// Material Class/UOM

export const getMaterialClassCodes = () => {
  return axios.get(`${baseUrl}/api/settings/material_class_codes/get`);
};

export const setMaterialClassCodes = (material_class_cd, material_class) => {
  const url = `${baseUrl}/api/settings/material_class_codes/set`;
  return axios.post(url, { material_class_cd, material_class });
};

export const deleteCodeTranslation = (
  material_class_cd_id,
  action,
  field_name
) => {
  const url = `${baseUrl}/api/settings/material_class/delete`;
  return axios.put(url, { material_class_cd_id, action, field_name });
};

export const getCodeTranslations = () => {
  return axios.get(`${baseUrl}/api/settings/code_translations/get`);
};

export const setNewCodeTranslation = (
  field_name,
  code_translation,
  target_code
) => {
  const url = `${baseUrl}/api/settings/code_translation/set`;
  return axios.post(url, { field_name, code_translation, target_code });
};

export const getUom = () => {
  return axios.get(`${baseUrl}/api/settings/uom/get`);
};

export const setNewUom = (uom_type, uom_type_cd) => {
  const url = `${baseUrl}/api/settings/uom/set`;
  return axios.post(url, { uom_type, uom_type_cd });
};

export const deleteMasterMaterialClass = (id) => {
  const url = `${baseUrl}/api/settings/material_class_master/delete`;
  return axios.post(url, { id });
};

export const deleteMasterUom = (id) => {
  const url = `${baseUrl}/api/settings/uom_master/delete`;
  return axios.post(url, { id });
};

// Hub and Spoke
export const getSpokes = () => {
  return axios.get(`${baseUrl}/api/hub/spokes`);
};

export const uploadToSpokes = (siteList, data) => {
  data.siteList = siteList;
  const url = `${baseUrl}/api/hub/upload/file/spoke`;
  return axios.post(url, data);
};

// Product merging

export const getMergeCandidates = (productUuidList) => {
  const url = `${baseUrl}/api/merge/candidates`;
  return axios.post(url, { productUuidList });
};

export const mergeCandidates = (targetProductUuid, sourceProductUuidList) => {
  const url = `${baseUrl}/api/merge/candidates/merge`;
  return axios.post(url, { targetProductUuid, sourceProductUuidList });
};

export const unmergeCandidates = (mergedProductUuidList) => {
  const url = `${baseUrl}/api/merge/candidates/unmerge`;
  return axios.put(url, { mergedProductUuidList });
};

export const guestCheckout = (data) => {
  let body = {
    userId: data.userId,
    guestName: data.checkoutName,
    guestEmail: data.checkoutEmail,
    guestPhone: data.checkoutPhone,
    productUUID: data.productId,
    productSkuUUID: data.productSkuId,
    contactByEmail: data.contactByEmail,
    contactByPhone: data.contactByPhone
  };
  const url = `${baseUrl}/api/user/checkout/guest/`;
  return axios.post(url, body);
};

// Multi-sample guest checkout — one customer, a set of {productUUID, productSkuUUID}.
// The server resolves the customer once and inserts every row together, so a partial
// checkout can't happen.
export const guestCheckoutBatch = (data) => {
  const body = {
    userId: data.userId,
    guestName: data.checkoutName,
    guestEmail: data.checkoutEmail,
    guestPhone: data.checkoutPhone,
    contactByEmail: data.contactByEmail,
    contactByPhone: data.contactByPhone,
    samples: data.samples,
  };
  const url = `${baseUrl}/api/user/checkout/guest/batch`;
  return axios.post(url, body);
};

// Resolves a QR code scanned during checkout into the SKUs it covers.
export const getProductCheckoutOptions = (productUUID) => {
  return axios.get(`${baseUrl}/api/user/product/${productUUID}/checkout-options`);
};

// QConnect

export const getCatalogCsv = () => {
  const url = `${baseUrl}/api/qconnect/getCatalogCsv`;
  return axios.get(url);
}

export const getQconnectToggle = () => {
  const url = `${baseUrl}/api/admin/getqconnecttoggle`;
  return axios.get(url);
}

export const setQconnectToggle = (value) => {
  const url = `${baseUrl}/api/admin/setqconnecttoggle`;
  return axios.post(url, { value });
}

export const getQconnectConfig = () => {
  const url = `${baseUrl}/api/admin/getqconnectconfig`;
  return axios.get(url);
}

export const setQconnectConfig = (config) => {
  const url = `${baseUrl}/api/admin/setqconnectconfig`;
  return axios.post(url, { config });
}

// AI

export const sendPromptMessage = (data) => {
  return axios.post(`${baseUrl}/api/ai/prompt/sendMessage`, data);  
}

export const clearPromptSession = (sessionId) => {
  return axios.post(
    `${baseUrl}/api/ai/prompt/clearHistory`,
    { sessionId }
  );  
}

export const deletePromptMessage = (sessionId, messageId) => {
  return axios.post(
    `${baseUrl}/api/ai/prompt/deleteMessage`,
    { sessionId, messageId }
  );  
}

export const deletePromptMessages = (sessionId, messageIds) => {
  return axios.post(
    `${baseUrl}/api/ai/prompt/deleteMessages`,
    { sessionId, messageIds: messageIds.toString() ?? '' }
  );  
}

export const getSystemInstructions = () => {
  return axios.get(`${baseUrl}/api/ai/prompt/systemInstructions`);  
}

export const getAIModels = () => {
  return axios.get(`${baseUrl}/api/ai/prompt/getModels`);  
}

export const getDefaultAIModel = () => {
  return axios.get(`${baseUrl}/api/ai/prompt/getDefaultModel`);  
}

export const getPromptSessions = () => {
  return axios.get(`${baseUrl}/api/ai/prompt/getSessions`);  
}

export const updatePromptSession = (sessionId, sessionName, modelConfig, systemInstructions) => {
  return axios.post(
    `${baseUrl}/api/ai/prompt/session/${sessionId}/update`,
    { sessionName, model: JSON.stringify(modelConfig), systemInstructions }
  );  
}

export const getPromptSessionHistory = (sessionId) => {
  return axios.get(`${baseUrl}/api/ai/prompt/session/${sessionId}/history`);  
}

export const autoProcess = (sessionId, modelConfig) => {
  return axios.post(
    `${baseUrl}/api/ai/prompt/autoProcess`, 
    { sessionId, modelConfig: JSON.stringify(modelConfig) }
  );  
}

// AI V2

export const getPromptToken = (sessionId) => {
  return axios.get(`${baseUrl}/api/ai/prompt/v2/session/${sessionId}/getToken`);  
}

export const getDistributorsForPrompt = () => {
  return axios.get(`${baseUrl}/api/ai/prompt/v2/getDistributors`);  
}

export const getManufacturersForPrompt = () => {
  return axios.get(`${baseUrl}/api/ai/prompt/v2/getManufacturers`);  
}

export const getSystemInstructionsForPrompt = () => {
  return axios.get(`${baseUrl}/api/ai/prompt/v2/getSystemInstructions`);  
}

export const getAlternateProductSku = (productSkuUUID) => {
  return axios.get(`${baseUrl}/api/product-search/alternate-sku/${productSkuUUID}`); 
} 

export const getLocationLimit = () => {
  const url = `${baseUrl}/api/admin/getlocationlimit`;
  return axios.get(url);
}

export const setLocationLimit = (value) => {
  const url = `${baseUrl}/api/admin/setlocationlimit`;
  return axios.post(url, { value });
}

export const getCalculationType = () => {
  const url = `${baseUrl}/api/admin/getcalctype`;
  return axios.get(url);
}

export const setCalculationType = (value) => {
  const url = `${baseUrl}/api/admin/setcalctype`;
  return axios.post(url, { value });
}

// Product Page Product Lists

export const getCollectionProducts = (productUUID, offset, limit) => {
  return axios.get(`${baseUrl}/api/product/${productUUID}/collection?offset=${offset}&limit=${limit}`);
}

export const getRelatedProducts = (productUUID, offset, limit) => {
  return axios.get(`${baseUrl}/api/product/${productUUID}/related?offset=${offset}&limit=${limit}`);
}

export const getDiscoveryProducts = (productUUID, offset, limit) => {
  return axios.get(`${baseUrl}/api/product/${productUUID}/discovery?offset=${offset}&limit=${limit}`);
}

// Vegas Marketing Leads

export const submitSRPLead = (formData) => {
  return axios.post(
    `${baseUrl}/api/srp/lead`,
    formData
  );
}

export const getShowVegasMarketingSelection = () => {
  return axios.get(`${baseUrl}/api/admin/getshowvegasmarketing`);
};

export const setShowVegasMarketingSelection = (value) => {
  return axios.post(`${baseUrl}/api/admin/setshowvegasmarketing`, { value });
};

// File Processing feature toggle (hidden users set it; controls customer visibility of the page)

export const getFileProcessingSelection = () => {
  return axios.get(`${baseUrl}/api/admin/getfileprocessingenabled`);
};

// Deep application health for the Internal Tools page (hidden admins).
export const getAppHealth = () => {
  return axios.get(`${baseUrl}/api/admin/health`);
};

export const setFileProcessingSelection = (value) => {
  return axios.post(`${baseUrl}/api/admin/setfileprocessingenabled`, { value });
};

// Custom Calculations

export const getCustomCalculations = () => {
  return axios.get(`${baseUrl}/api/admin/getcustomcalcconfig`);
}

export const setCustomCalculations = (config) => {
  return axios.post(`${baseUrl}/api/admin/setcustomcalcconfig`, { config });
}

export const getCalcTemplates = () => {
  return axios.get(`${baseUrl}/api/admin/getcalctemplates`);
}

export const setCalcTemplate = (template) => {
  return axios.post(`${baseUrl}/api/admin/setcalctemplate`, { template });
}

export const getCalcGraphs = () => {
  return axios.get(`${baseUrl}/api/admin/calcgraphs`);
}

export const getCalcGraph = (calc_graph_id) => {
  return axios.get(`${baseUrl}/api/admin/calcgraphs/${calc_graph_id}`);
}

export const saveCalcGraph = (name, graph, template_key) => {
  return axios.post(`${baseUrl}/api/admin/calcgraphs/save`, { name, graph, template_key });
}

export const updateCalcGraph = (calc_graph_id, graph, name) => {
  return axios.post(`${baseUrl}/api/admin/calcgraphs/update`, { calc_graph_id, graph, name });
}

export const deleteCalcGraph = (calc_graph_id) => {
  return axios.post(`${baseUrl}/api/admin/calcgraphs/delete`, { calc_graph_id });
}

// `source` targets a specific graph ({ template } or { graphId }); without
// it the visualizer renders the live pricing config.
const visualizerSourceParams = (source) => {
  if (source?.template) return `&template=${source.template}`;
  if (source?.graphId) return `&graphId=${source.graphId}`;
  return '';
};

export const getVisualizer = (orientation, source) => {
  return axios.get(`${baseUrl}/api/calculations/visualizer?orientation=${orientation}${visualizerSourceParams(source)}`);
}

export const getPricingVisualizer = (productUUID, roleId, costId, orientation, source) => {
  return axios.get(`${baseUrl}/api/calculations/visualizer/product/${productUUID}?roleId=${roleId}&costId=${costId}&orientation=${orientation}${visualizerSourceParams(source)}`);
}

export const getOptionAttributes = () => {
  return axios.get(`${baseUrl}/api/calculations/visualizer/retreiveattributes`);
}

// Plain-English description of the live calc graph (or a template/saved graph
// via `source`). Returns { available: false } when custom calc isn't on.
export const getCalcDescription = (source) => {
  const params = visualizerSourceParams(source).replace(/^&/, '');

  return axios.get(`${baseUrl}/api/calculations/description${params ? `?${params}` : ''}`);
}

// Customer-admin pricing model switch (Cost Adjustments page). `template` is
// 'margin' | 'markup' | 'graph:<calc_graph_id>'. Only works once the site is
// on the custom calc engine; the server returns 409 otherwise.
export const setPricingModel = (template) => {
  return axios.post(`${baseUrl}/api/calculations/model`, { template });
}

export const getUseCustomCalcFunctionsSelection = () => {
  return axios.get(`${baseUrl}/api/admin/getusecustomcalcfunctions`);
};

export const setUseCustomCalcFunctionsSelection = (value) => {
  return axios.post(`${baseUrl}/api/admin/setusecustomcalcfunctions`, { value });
};

// File Ingestion Queue

// `detected` (optional) carries what vendor detection suggested for this file
// ({ detectedVendor, detectedTier, detectedConfidence }) so the server can log suggestion vs.
// actual choice — the accuracy measurement behind eventually dropping the vendor question.
// `sheetName` (optional): for multi-tab spreadsheets, the worksheet the user picked — only that
// tab is processed.
export const addFileToQueue = (data, distributorName, distributorUUID, fileName, detected, sheetName) => {
  return axios.post(`${baseUrl}/api/upload/ingestion/files`, data, { params: { distributorName, distributorUUID, fileName, ...(detected || {}), ...(sheetName ? { sheetName } : {}) } });
};

export const getFileList = () => {
  return axios.get(`${baseUrl}/api/upload/ingestion/files`);
};

// Pre-flight: ask the server whether an upload should use an existing mapping (legacy engine) or
// the AI processor. Returns { engine: 'mapping'|'ai', transform?, transformType?, matchedBy? }.
export const getRouteDecision = (distributorName, fileName) => {
  return axios.get(`${baseUrl}/api/upload/ingestion/route-decision`, { params: { distributorName, fileName } });
};

// Help page catalog (any logged-in user; server returns absolute URLs)
export const getHelpCatalog = () => {
  return axios.get(`${baseUrl}/api/help/catalog`);
};

// Help video review (internal tools — hidden admins)
export const getHelpReviews = () => {
  return axios.get(`${baseUrl}/api/help-review/list`);
};

export const approveHelpVideo = (key, by) => {
  return axios.post(`${baseUrl}/api/help-review/${encodeURIComponent(key)}/approve`, { by });
};

export const requestHelpVideoChanges = (key, by, note) => {
  return axios.post(`${baseUrl}/api/help-review/${encodeURIComponent(key)}/request-changes`, { by, note });
};

export const setHelpVideoActive = (key, active) => {
  return axios.post(`${baseUrl}/api/help-review/${encodeURIComponent(key)}/active`, { active });
};

export const deleteHelpVideo = (key) => {
  return axios.post(`${baseUrl}/api/help-review/${encodeURIComponent(key)}/delete`, {});
};

export const updateFileStatus = (file_uuid, data) => {
  return axios.post(`${baseUrl}/api/upload/ingestion/files/${file_uuid}/status`, data);
};

export const getDistributorList = () => {
  return axios.get(`${baseUrl}/api/upload/ingestion/distributors`);
};

// Idempotent vendor create/resolve. Called once per proposed vendor before any bulk file is queued,
// so every upload carries a real distributorUUID.
export const createDistributor = (distributorName) => {
  return axios.post(`${baseUrl}/api/upload/ingestion/distributors`, { distributorName });
};

// Per-vendor hands-off import: clean processed files (no unresolved codes, no missing identity,
// zero probable duplicates) import automatically when enabled.
export const setDistributorAutoImport = (uuid, enabled) => {
  return axios.put(`${baseUrl}/api/upload/ingestion/distributors/${uuid}/auto-import`, { enabled });
};

// Bulk vendor detection. `files` is one fingerprint per dropped file:
//   { key, fileName, folderName, columns: [{ header, samples: [] }], textSample }
// Returns a ranked vendor guess per file plus a batch summary. Suggests only — creates nothing.
export const detectVendors = (files) => {
  return axios.post(`${baseUrl}/api/upload/ingestion/detect-vendors`, { files });
};

// type 'rejected' downloads the rows the processor excluded from the import (with reasons);
// default downloads the processed output.
// type: undefined = processed output, 'rejected' = validation rejects, 'original' = the uploaded file
export const downloadIngestionFile = (uuid, type) => {
  const suffix = type ? `?type=${type}` : '';
  return axios.get(`${baseUrl}/api/upload/ingestion/files/${uuid}/download${suffix}`, { responseType: 'blob' });
};

export const cancelIngestionFile = (uuid) => {
  return axios.delete(`${baseUrl}/api/upload/ingestion/files/${uuid}`);
};

// AI processing cost: per-file runs + totals, re-price stored rows, and a fleet-wide rollup.
export const getFileProcessingCost = (uuid) => {
  return axios.get(`${baseUrl}/api/upload/ingestion/files/${uuid}/cost`);
};

export const repriceFileProcessingCost = (uuid) => {
  return axios.post(`${baseUrl}/api/upload/ingestion/files/${uuid}/reprice`);
};

export const repriceAllProcessingCosts = () => {
  return axios.post(`${baseUrl}/api/upload/ingestion/reprice`);
};

export const getAiCostSummary = () => {
  return axios.get(`${baseUrl}/api/upload/ingestion/cost-summary`);
};

// Customer-facing credit meter (points only — no USD/model/tokens).
export const getAiCreditMeter = () => {
  return axios.get(`${baseUrl}/api/upload/ingestion/ai-credit/meter`);
};

// Monthly credit allotment in dollars (hidden users only).
export const getAiCreditLimit = () => {
  return axios.get(`${baseUrl}/api/admin/getaicreditlimit`);
};

export const setAiCreditLimit = (value) => {
  return axios.post(`${baseUrl}/api/admin/setaicreditlimit`, { value });
};

// One-month credit grants (hidden users only).
export const getAiCreditGrants = () => {
  return axios.get(`${baseUrl}/api/upload/ingestion/ai-credit/grants`);
};

export const addAiCreditGrant = (amountUsd, note) => {
  return axios.post(`${baseUrl}/api/upload/ingestion/ai-credit/grant`, { amountUsd, note });
};

export const voidAiCreditGrant = (id) => {
  return axios.delete(`${baseUrl}/api/upload/ingestion/ai-credit/grant/${id}`);
};

// File feedback: triage (free), remap the output (free), or reprocess the original (billed).
export const triageFileFeedback = (uuid, feedback) => {
  return axios.post(`${baseUrl}/api/upload/ingestion/files/${uuid}/feedback/triage`, { feedback });
};

export const applyFileRemap = (uuid, transforms) => {
  return axios.post(`${baseUrl}/api/upload/ingestion/files/${uuid}/feedback/remap`, { transforms });
};

export const reprocessFileWithFeedback = (uuid, feedback) => {
  return axios.post(`${baseUrl}/api/upload/ingestion/files/${uuid}/feedback/reprocess`, { feedback });
};

// Plain re-run against the current AI reference context — no feedback. Billed, like the above.
export const reprocessIngestionFile = (uuid) => {
  return axios.post(`${baseUrl}/api/upload/ingestion/files/${uuid}/reprocess`, {});
};

export const dryRunImport = (data) => {
  return axios.post(`${baseUrl}/api/upload/file/dry-run`, data);
};

// Preview for an already-canonical file (processor SPEC output): preserves all columns (incl. role
// price columns) and runs code-translation correction. Returns { dataPreview, issues, transformType }.
export const getCanonicalPreview = (dataPreview, fileName) => {
  return axios.post(`${baseUrl}/api/upload/file/canonical-preview`, { dataPreview, fileName });
};

// SPEC/canonical files: server-side staging (server loads the delivered CSV into a temp table; these
// run against ALL rows, fast — no client download/parse/post). Keyed by ingestion_file uuid.
export const stagePreview = (uuid) => axios.post(`${baseUrl}/api/upload/ingestion/files/${uuid}/stage-preview`, {});
// skipSpecs = [{ fieldName, value }] from ResolveCodesDialog "skip rows" choices — the server drops the
// matching rows from the staged table before re-validating / counting / importing.
export const stagedDryRun = (uuid, skipSpecs = []) => axios.post(`${baseUrl}/api/upload/ingestion/files/${uuid}/stage-dry-run`, { skipSpecs });
export const stagedImport = (uuid, skipSpecs = []) => axios.post(`${baseUrl}/api/upload/ingestion/files/${uuid}/stage-import`, { skipSpecs });

// Rule-builder spec management (transform_type='SPEC' rows in file_upload_transform).
export const listSpecs = () => axios.get(`${baseUrl}/api/upload/specs`);
export const getSpec = (id) => axios.get(`${baseUrl}/api/upload/specs/${id}`);
export const saveSpec = (payload) => axios.post(`${baseUrl}/api/upload/specs`, payload);
// Migration accelerator: list legacy SQL transforms + auto-convert one to a draft SPEC.
export const listSqlSources = () => axios.get(`${baseUrl}/api/upload/specs/sql-sources`);
export const convertSqlToSpec = (id) => axios.get(`${baseUrl}/api/upload/specs/convert/${id}`);
// Canonical showroom-pricing target columns [{ key, label, group }] for the visual rule builder
// (static set + this instance's per-role price-override columns).
export const listTargetColumns = () => axios.get(`${baseUrl}/api/upload/specs/target-columns`);

export const sqlSkipRows = (fileName, fieldName, value) => {
  return axios.post(`${baseUrl}/api/upload/file/sql/skip`, { fileName, fieldName, value });
};

export const sqlRevalidate = (fileName) => {
  return axios.post(`${baseUrl}/api/upload/file/sql/revalidate`, { fileName });
};

export const markIngestionFileImported = (uuid, metrics) => {
  return axios.post(`${baseUrl}/api/upload/ingestion/files/${uuid}/imported`, { metrics });
};

// ── QR style presets (admin) ──────────────────────────────────────────────────

export const listQrPresets = () => {
  return axios.get(`${baseUrl}/api/settings/qr_style_presets/list`);
};

export const getQrPreset = (presetId) => {
  const q = presetId ? `?preset_id=${presetId}` : '';
  return axios.get(`${baseUrl}/api/settings/qr_style_presets/get${q}`);
};

export const createQrPreset = (preset) => {
  return axios.post(`${baseUrl}/api/settings/qr_style_presets/create`, preset);
};

export const updateQrPreset = (preset) => {
  return axios.put(`${baseUrl}/api/settings/qr_style_presets/set`, preset);
};

export const deleteQrPreset = (preset_id) => {
  return axios.put(`${baseUrl}/api/settings/qr_style_presets/delete`, { preset_id });
};

export const markQrPresetUsed = (preset_id) => {
  return axios.put(`${baseUrl}/api/settings/qr_style_presets/use`, { preset_id });
};

export const uploadQrLogo = (formData) => {
  return axios.post(`${baseUrl}/api/settings/qr_style_presets/logo`, formData);
};

export const deleteQrLogo = (preset_id) => {
  return axios.put(`${baseUrl}/api/settings/qr_style_presets/logo/delete`, { preset_id });
};

// ---- Price tier bands ----
// location_id null/'' selects the instance-wide default set; a numeric id selects
// that store's own set. The GET also returns every location plus how many bands
// each one has, for the scope picker.

export const getPriceTierMode = () => {
  return axios.get(`${baseUrl}/api/admin/pricetiermode`);
};

export const setPriceTierMode = (value) => {
  return axios.post(`${baseUrl}/api/admin/pricetiermode`, { value });
};

export const getPriceTierBands = (location_id) => {
  const q = location_id != null && location_id !== '' ? `?location_id=${location_id}` : '';
  return axios.get(`${baseUrl}/api/settings/price_tiers/get${q}`);
};

export const setPriceTierBands = (location_id, bands) => {
  return axios.put(`${baseUrl}/api/settings/price_tiers/set`, { location_id, bands });
};

// ---- External system integrations ----
// Provider-scoped, so a second system needs no new action functions. API keys are
// never returned by the server — reads carry a masked hint, and a save that omits
// the key (or echoes the mask) leaves the stored one alone.

export const listIntegrations = () => {
  return axios.get(`${baseUrl}/api/integrations`);
};

export const getIntegrationConfig = (provider) => {
  return axios.get(`${baseUrl}/api/integrations/${provider}/config`);
};

export const setIntegrationConfig = (provider, config) => {
  return axios.put(`${baseUrl}/api/integrations/${provider}/config`, config);
};

export const testIntegration = (provider, config) => {
  return axios.post(`${baseUrl}/api/integrations/${provider}/test`, config ?? {});
};

export const getIntegrationContactTypes = (provider) => {
  return axios.get(`${baseUrl}/api/integrations/${provider}/contact-types`);
};

export const syncIntegrationNow = (provider) => {
  return axios.post(`${baseUrl}/api/integrations/${provider}/sync`, {});
};

export const getIntegrationNotesForLead = (userId) => {
  return axios.get(`${baseUrl}/api/integrations/leads/${userId}/notes`);
};

// User-facing preset list for the print dialog (returns presets + last_preset_id)
export const getQrPresetsForUser = () => {
  return axios.get(`${baseUrl}/api/user/qr_presets`);
};

// fresh=true forces a full re-scan, ignoring the incremental watermark.
export const scanDuplicates = (fresh = false) => {
  const params = fresh ? { fresh: '1' } : {};
  return axios.post(`${baseUrl}/api/merge/duplicate-scan`, null, { params });
};

// Clear current (pending) matches and start a fresh scan.
export const resetDuplicateScan = () => {
  return axios.post(`${baseUrl}/api/merge/duplicate-scan/reset`);
};

export const getScanStatus = () => {
  return axios.get(`${baseUrl}/api/merge/duplicate-scan/status`);
};

// dryRun=true previews the merge plan without merging. force=true runs even when
// the auto-merge toggle is off (explicit admin action).
export const runAutoMerge = (dryRun = false, force = false) => {
  const params = {};
  if (dryRun) params.dry_run = '1';
  if (force) params.force = '1';
  return axios.post(`${baseUrl}/api/merge/auto-merge`, null, { params });
};

export const rescorePendingDuplicates = () => {
  return axios.post(`${baseUrl}/api/merge/rescore-pending`);
};

export const getDuplicateCandidates = (status = 'pending', offset = 0, limit = 50, search = '', minScore = '', mergeOrigin = '', printedOnly = false) => {
  const params = { status, offset, limit };
  if (search) params.search = search;
  if (minScore) params.min_score = minScore;
  if (mergeOrigin) params.merge_origin = mergeOrigin;
  if (printedOnly) params.printed_only = '1';
  return axios.get(`${baseUrl}/api/merge/duplicate-candidates`, { params });
};

export const updateDuplicateCandidateStatus = (id, status) => {
  return axios.put(`${baseUrl}/api/merge/duplicate-candidates/${id}/status`, { status });
};

export const getDupSettings = () => {
  return axios.get(`${baseUrl}/api/merge/duplicate-settings`);
};

export const updateDupSettings = (thresholds) => {
  return axios.put(`${baseUrl}/api/merge/duplicate-settings`, thresholds);
};

export const getVariantWords = () => {
  return axios.get(`${baseUrl}/api/merge/duplicate-variant-words`);
};

export const addVariantWord = (word) => {
  return axios.post(`${baseUrl}/api/merge/duplicate-variant-words`, { word });
};

export const removeVariantWord = (id) => {
  return axios.delete(`${baseUrl}/api/merge/duplicate-variant-words/${id}`);
};

export const getDuplicateFlags = (uuids) => {
  return axios.post(`${baseUrl}/api/merge/duplicate-candidates/flags`, { uuids });
};

export const getMfgGroups = () => {
  return axios.get(`${baseUrl}/api/merge/manufacturer-groups`);
};

export const createMfgGroup = (group_name) => {
  return axios.post(`${baseUrl}/api/merge/manufacturer-groups`, { group_name });
};

export const deleteMfgGroup = (id) => {
  return axios.delete(`${baseUrl}/api/merge/manufacturer-groups/${id}`);
};

export const addMfgGroupMember = (groupId, manufacturer_uuid) => {
  return axios.post(`${baseUrl}/api/merge/manufacturer-groups/${groupId}/members`, { manufacturer_uuid });
};

export const removeMfgGroupMember = (groupId, memberId) => {
  return axios.delete(`${baseUrl}/api/merge/manufacturer-groups/${groupId}/members/${memberId}`);
};

export const searchByLabel = (fields) => {
  return axios.post(`${baseUrl}/api/ai/label-search`, fields);
};

// Queues `quantity` labels for EACH product. Accepts one uuid or a selection.
export const addToQueueWithQuantity = (productUUIDs, quantity) => {
  const list = Array.isArray(productUUIDs) ? productUUIDs : [productUUIDs];
  return axios.post(`${baseUrl}/api/user/queue/copies`, {
    productUUIDs: list,
    quantity,
  });
};

export const scanLabelImage = (imageFile) => {
  const formData = new FormData();
  formData.append('label_image', imageFile);
  return axios.post(`${baseUrl}/api/ai/label-scan`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
